import React, { useEffect } from 'react';
import PageLayout from '../components/PageLayout/PageLayout';
import usePageTitle from '../utils/usePageTitle';
import './PrivacyPage.css';

const PrivacyPage = () => {
  usePageTitle('Privacy Policy');

  useEffect(() => {
    (function(d, s, id) {
      var js, tjs = d.getElementsByTagName(s)[0];
      js = d.createElement(s); js.id = id;
      js.src = "https://app.termly.io/embed-policy.min.js";
      tjs.parentNode.insertBefore(js, tjs);
    }(document, 'script', 'termly-jssdk'));
  }, []);
  
  const rawHtml = ``;

  return (
    <PageLayout>
      <div className="privacy-page">
        <div name="termly-embed" data-id="9c5fcfdc-563c-4dfd-8697-84df0dafed91"></div>
      </div>
    </PageLayout>
  );
};

export default PrivacyPage;